import * as shippingApi from '../../api/shipping-methods-api';
import { IITAPISResult, IResult } from '../../models/result-models';
import { IShippingMethods, IUpdateShippingMethod } from '../../models/shipping';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_SHIPPING_METHODS_SUCCESS = 'LOAD_SHIPPING_METHODS_SUCCESS';
export const LOAD_SHIPPING_METHODS_ERROR = 'LOAD_SHIPPING_METHODS_ERROR';

export const UPDATE_SHIPPING_METHOD_SUCCESS = 'UPDATE_SHIPPING_METHOD_SUCCESS';
export const UPDATE_SHIPPING_METHOD_ERROR = 'UPDATE_SHIPPING_METHOD_ERROR';

// Actions
const loadShippingMethodsSuccess = (payload: IResult<IShippingMethods[]>) => ({
    type: LOAD_SHIPPING_METHODS_SUCCESS,
    payload,
});
const updateShippingMethodSuccess = (payload: IResult<IITAPISResult>) => ({
    type: UPDATE_SHIPPING_METHOD_SUCCESS,
    payload,
});

// Thunks
export const loadShippingMethods = (billTo: string, shipTo: string) => {
    return async (dispatch: any) => {
        dispatch(beginApiCall());
        try {
            const result = await shippingApi.getShippingMethods(billTo, shipTo);
            dispatch(loadShippingMethodsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};

export const changeShippingMethod = (shippingMethod: IUpdateShippingMethod) => {
    return async (dispatch: any) => {
        dispatch(beginApiCall());
        try {
            const result = await shippingApi.updateShippingMethod(
                shippingMethod
            );
            dispatch(updateShippingMethodSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};
